import {StyleSheet} from 'react-native';

import platformConfig from '/config/platform.config';
import {darkGray, denim} from '/theme/color/on.color';
import {codGray, pearl} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  radioButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 45,
    marginVertical: 10,
    marginLeft: 10,
  },
  radioButton: {
    height: 20,
    width: 20,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: codGray,
    alignItems: 'center',
    //marginLeft: 8,
    justifyContent: 'center',
  },
  radioButtonSelected: {
    height: 20,
    width: 20,
    backgroundColor: pearl,
    borderRadius: 10,
    borderWidth: 5,
    borderColor: denim,
    alignItems: 'center',
    //marginLeft: 8,
    justifyContent: 'center',
  },
  radioButtonText: {
    fontSize: 14,
    marginLeft: 16,
    color: codGray,
  },
  radioButtonTextSelected: {
    fontSize: 14,
    marginLeft: 16,
    fontWeight: '600',
  },
  radioButtonTextDisabled: {
    fontSize: 14,
    marginLeft: 16,
    color: darkGray, // grayish color
  },
  filterTypeText: {
    fontSize: 14,
    fontWeight: platformConfig.select({
      ios: '800',
      android: 'bold',
    }),
    color: codGray,
    marginVertical: 10,
  },
  filterHeadingText: {
    fontWeight: platformConfig.select({web: '800'}),
  },
  checkboxItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 10,
    paddingLeft: 10,
  },
  checkboxIcon: {
    fontSize: 20,
    borderRadius: 2,
    color: pearl,
    backgroundColor: codGray,
    marginRight: 12,
  },
  checkboxIconSelected: {
    fontSize: 20,
    color: denim,
    borderRadius: 2,
    backgroundColor: 'transparent',
  },
  checkboxLabel: {
    fontSize: 15,
    color: codGray,
  },
  line: {
    height: 1,
    backgroundColor: darkGray,
    width: '90%',
    margin: 10,
  },
  rangeInput: {
    borderWidth: 1,
    borderColor: darkGray,
    borderRadius: 8,
    paddingHorizontal: 10,
    paddingVertical: 10,
    //marginHorizontal: 10,
    marginTop: 8,
    fontSize: 14,
  },
  rangeInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    //marginHorizontal: 10,
    marginTop: 8,
  },
  rangeInputBetween: {
    flex: 1,
    borderWidth: 1,
    borderColor: darkGray,
    borderRadius: 10,
    paddingHorizontal: 10,
    paddingVertical: 10,
    marginHorizontal: 0,
    marginTop: 0,
    fontSize: 14,
  },
  rangeSeparator: {
    marginHorizontal: 8,
    fontSize: 14,
    fontWeight: 'bold',
    alignSelf: 'center',
  },
  rangeInputError: {
    borderWidth: 1,
    borderColor: 'red',
    borderRadius: 8,
    paddingHorizontal: 10,
    paddingVertical: 10,
    //marginHorizontal: 10,
    marginTop: 8,
    fontSize: 14,
  },
  rangeInputBetweenError: {
    flex: 1,
    borderWidth: 1,
    borderColor: 'red',
    borderRadius: 10,
    paddingHorizontal: 10,
    paddingVertical: 10,
    marginHorizontal: 0,
    marginTop: 0,
    fontSize: 14,
  },
  errorText: {
    color: 'red',
    fontSize: 12,
    marginBottom: 8,
  },
  inputWithError: {
    flex: 1,
  },
  wrapper: {
    paddingBottom: 16,
  },
});
